// 9fbef606107a605d69c0edbcd8029e5d
import React, { Fragment } from 'react';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import isEqual from 'lodash/isEqual';
import createValidateMethod from '@tcp/core/src/utils/formValidation/createValidateMethod';
import getStandardConfig from '@tcp/core/src/utils/formValidation/validatorStandardConfig';
import PropTypes from 'prop-types';
import { isGymboree, getViewportInfo, getBrandInCaps, routerPush } from '@tcp/core/src/utils';
import Button from '@tcp/core/src/components/common/atoms/Button';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Row from '@tcp/core/src/components/common/atoms/Row';
import TextBox from '@tcp/core/src/components/common/atoms/TextBox';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import RichText from '@tcp/core/src/components/common/atoms/RichText';
import { formatPhoneNumber } from '@tcp/core/src/utils/formValidation/phoneNumber';
import SMSTapToJoin from '@tcp/core/src/components/common/molecules/SMSTapToJoin';
import Grid from '@tcp/core/src/components/common/molecules/Grid';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { getBrand, getIconPath, isCanada } from '@tcp/core/src/utils/utils';
import InputCheckbox from '@tcp/core/src/components/common/atoms/InputCheckbox';
import Image from '@tcp/core/src/components/common/atoms/Image';
import {
  SMS_SIGNUP_FORM_RENDER_TAP_TO_JOIN,
  SNJ_HP_PRIMARY_FILL,
} from '@tcp/core/src/constants/brandSpecific.constants';
import {
  GlobalGenericLabels,
  GLOBAL_GENERIC_LABELS,
  lblShopNow,
} from '@tcp/core/src/utils/labels/globalGeneric.labels';
import {
  GLOBAL_EMAIL_SIGN_UP_LABELS,
  GlobalEmailSignUpLabels,
} from '@tcp/core/src/utils/labels/globalEmailSignUp.labels';
import {
  GLOBAL_SMS_SIGN_UP_LABELS,
  GlobalSmsSignUpLabels,
} from '@tcp/core/src/utils/labels/globalSmsSignUp.labels';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
  getDynamicLabelValues,
} from '@tcp/core/src/utils/labels/labelUtilty';
import smsSignupDynamicStore from '../container/smsSignupDynamicStore';
import SignupConfirm from '../../../molecules/SignupConfirm';
import SignupFormIntro from '../../../molecules/SignupFormIntro';
import smsSignupStyle from '../styles/SmsSignupForm.style';
import config from '../config';

const SMS_SUBSCRIPTION_STATUS = {
  MDN_ALREADY_SUBSCRIBED: 'MdnAlreadySubscribed',
  MDN_CONFIRMATION_BLOCK: 'MdnHasConfirmationBlock',
};
const isMdnSubscribedOrBlocked = (subscription) => {
  return (
    subscription?.data?.status === SMS_SUBSCRIPTION_STATUS.MDN_ALREADY_SUBSCRIBED ||
    subscription?.data?.status === SMS_SUBSCRIPTION_STATUS.MDN_CONFIRMATION_BLOCK
  );
};
class SmsSignupForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.globalGenericLabels = getLabelFromCopyOrFromTranslation(
      GLOBAL_GENERIC_LABELS,
      GlobalGenericLabels
    );

    this.emailSignUpLabels = getLabelFromCopyOrFromTranslation(
      GLOBAL_EMAIL_SIGN_UP_LABELS,
      GlobalEmailSignUpLabels
    );

    this.smsSignUpLabels = getLabelFromCopyOrFromTranslation(
      GLOBAL_SMS_SIGN_UP_LABELS,
      GlobalSmsSignUpLabels
    );

    this.emailSignUpNoThanksText = renderLabel(
      this.emailSignUpLabels.lbl_no_thanks,
      'lbl_no_thanks'
    );
    this.genericErrorText = renderLabel(
      this.smsSignUpLabels.lbl_SignUp_genericError,
      'lbl_SignUp_genericError'
    );

    this.imageAltLabelText = renderLabel(
      this.smsSignUpLabels.lbl_SignUp_imageAlt,
      'lbl_SignUp_imageAlt'
    );
    this.storeLocatorLabelText = renderLabel(
      this.smsSignUpLabels.lbl_SignUp_storeLocatorLabel,
      'lbl_SignUp_storeLocatorLabel'
    );
    this.placeholderLabelText = renderLabel(
      this.smsSignUpLabels.lbl_SignUp_placeholderText,
      'lbl_SignUp_placeholderText'
    );
    this.joinButtonLabelText = renderLabel(
      this.smsSignUpLabels.lbl_SignUp_joinButtonLabel,
      'lbl_SignUp_joinButtonLabel'
    );

    this.imageSrcUrl = getDynamicLabelValues('dynamic.global_d.lbl_sms_SignUp_imageSrc');
    this.checkBoxTcpBrandText = getDynamicLabelValues(
      'dynamic.global_d.lbl_sms_SignUp_tcpSignUpLabel'
    );
    this.checkBoxGymBrandText = getDynamicLabelValues(
      'dynamic.global_d.lbl_sms_SignUp_gymSignUpLabel'
    );
    this.shopNowBtnUrlTarget = getDynamicLabelValues(
      'dynamic.global_d.lbl_sms_SignUp_shopNowBtnUrlTarget'
    );
    this.validationErrorLabel = getDynamicLabelValues(
      'dynamic.global_d.lbl_sms_validationErrorLabel'
    );
    this.shopNowBtnUrl = getDynamicLabelValues('dynamic.global_d.lbl_SignUp_shopNowBtnUrl');
    this.storeLocatorUrl = getDynamicLabelValues('dynamic.global_d.lbl_SignUp_storeLocatorUrl');

    this.shopNowLabel = renderLabel(this.globalGenericLabels[lblShopNow], 'lbl_shop_now');
  }

  componentDidMount() {
    const { subscription, trackSubscriptionSuccess, defaultStore } = this.props;
    if (subscription.success) {
      trackSubscriptionSuccess(defaultStore);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { subscription: newSubscription, emailSubscription } = nextProps;
    if (
      newSubscription.success &&
      !emailSubscription?.success &&
      !isMdnSubscribedOrBlocked(newSubscription) &&
      newSubscription.component !== 'footer'
    ) {
      routerPush(`/content?contentType=email-subscribe&fromPage=sms`, `/content/email-subscribe`);
      return false;
    }
    return !(isEqual(nextProps, this.props) && isEqual(nextState, this.state));
  }

  componentDidUpdate({ subscription: oldSubscription }) {
    const { subscription, trackSubscriptionSuccess, defaultStore } = this.props;
    if ((subscription.error || subscription.success) && this.formSubmitPromise) {
      if (subscription.error) {
        this.formSubmitPromise.reject();
      } else {
        if (subscription?.data?.status === SMS_SUBSCRIPTION_STATUS.MDN_ALREADY_SUBSCRIBED) {
          this.formSubmitPromise.reject(SMS_SUBSCRIPTION_STATUS.MDN_ALREADY_SUBSCRIBED);
        } else if (subscription?.data?.status === SMS_SUBSCRIPTION_STATUS.MDN_CONFIRMATION_BLOCK) {
          this.formSubmitPromise.reject(SMS_SUBSCRIPTION_STATUS.MDN_CONFIRMATION_BLOCK);
        }
        this.formSubmitPromise.resolve();
      }
      this.formSubmitPromise = null;
    }

    if (subscription.success !== oldSubscription.success && subscription.success) {
      trackSubscriptionSuccess(defaultStore);
    }
  }

  submitForm = async (formObj) => {
    await smsSignupDynamicStore();
    const { submitSmsSubscription, clearSmsSignupForm, validateSignupSmsPhoneNumber } = this.props;
    const { signupPhoneNumber, optPhoneSignupSecondBrand } = formObj;
    const genericErrorLabel = this.genericErrorText === 'lbl_SignUp_genericError' && '';
    return validateSignupSmsPhoneNumber(signupPhoneNumber)
      .then((subscription) => {
        if (subscription.error) {
          return Promise.reject();
        }
        /*
         Faking this because redux-form `submitting` based on promise resolve
       and we will resolve formSubmitPromise only when the state has success flag on
       componentDidUpdate.
       */
        return new Promise((resolve, reject) => {
          clearSmsSignupForm();
          this.formSubmitPromise = { resolve, reject };
          submitSmsSubscription({
            footerTopSmsSignup: signupPhoneNumber,
            isTextOptInSecondBrand: optPhoneSignupSecondBrand,
          });
        });
      })
      .catch((err) => {
        let error = {
          signupPhoneNumber: genericErrorLabel || this.validationErrorLabel,
        };
        if (err === SMS_SUBSCRIPTION_STATUS.MDN_ALREADY_SUBSCRIBED) {
          error = { signupPhoneNumber: this.validationErrorLabel };
        }
        throw new SubmissionError({
          ...error,
          _error: error,
        });
      });
  };

  getImageData = () => {
    const { imageData } = this.props;
    return imageData && Object.keys(imageData).length > 0
      ? imageData
      : {
          url: this.imageSrcUrl,
          alt: this.imageAltLabelText,
        };
  };

  renderTapToJoin = (isGym) => {
    const { className, noModal, closeModal, smsDisclaimer, smsFromPage } = this.props;
    const { right } = noModal ? config.pageColProps : config.modalColProps;
    const smsSignUpIconPath = getIconPath(SMS_SIGNUP_FORM_RENDER_TAP_TO_JOIN[getBrandInCaps()]);

    return (
      <Grid>
        <Row fullBleed={{ large: true }} className={`${className} wrapper form_container`}>
          <Col colSize={right} className="smsform__wrapper form-wrapper marginRightZero">
            <div className="smsform__content-join">
              <Row fullBleed>
                {!noModal && (
                  <Col
                    colSize={{ small: 6, medium: 6, large: 10 }}
                    offsetLeft={{ small: 0, medium: 1, large: 1 }}
                    className="logo-wrapper"
                  >
                    <Image className="logo" aria-hidden="true" src={smsSignUpIconPath} />
                  </Col>
                )}
              </Row>
              <div className="button-wrapper-tap-join">
                <SMSTapToJoin isWhite={false} smsFromPage={smsFromPage} isGym={isGym} />
                {smsFromPage === 'overlay' && (
                  <Row>
                    <Col className="no-thanks-wrapper" colSize={{ small: 4, medium: 4, large: 6 }}>
                      <Anchor
                        className="no-thanks-sms"
                        handleLinkClick={(e) => {
                          e.preventDefault();
                          closeModal();
                        }}
                        noLink
                      >
                        {this.emailSignUpNoThanksText}
                      </Anchor>
                    </Col>
                  </Row>
                )}
              </div>
              <Row>
                <Col colSize={{ large: 10, medium: 8, small: 6 }} className="termscontainer">
                  {smsDisclaimer && smsDisclaimer.richText ? (
                    <RichText richTextHtml={smsDisclaimer.richText} />
                  ) : null}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Grid>
    );
  };

  // eslint-disable-next-line
  render() {
    const {
      className,
      subscription,
      valid,
      submitting,
      handleSubmit,
      noModal,
      closeModal,
      smsDisclaimer,
      smsFromPage,
      fromPage,
    } = this.props;
    const { left, right } = noModal ? config.pageColProps : config.modalColProps;
    const { IMG_DATA_MODAL, IMG_DATA_PAGE } = config;
    const isGym = isGymboree();

    const brand = getBrand();

    const checkBoxBrandLabelText = isGym ? this.checkBoxGymBrandText : this.checkBoxTcpBrandText;

    const isCanadaCheck = isCanada();
    const { isMobile } = getViewportInfo() || {};
    if (isMobile) {
      return this.renderTapToJoin(isGym);
    }

    return (
      <Fragment>
        {subscription.success && !isMdnSubscribedOrBlocked(subscription) ? (
          <Grid className="full-height">
            <Row
              fullBleed
              className={`${className} full-height ${noModal ? 'smssubscribe__wrapper' : ''}`}
            >
              {!noModal && (
                <Col
                  isNotInlineBlock
                  colSize={left}
                  hideCol={{ small: true, medium: true }}
                  className="img-wrapper"
                >
                  <DamImage
                    imgConfigs={noModal ? IMG_DATA_PAGE : IMG_DATA_MODAL}
                    imgData={this.getImageData()}
                  />
                </Col>
              )}
              <Col
                isNotInlineBlock
                colSize={right}
                ignoreGutter={{ large: true }}
                className="sms-signup-content smsform__wrapper form-wrapper"
                aria-live="polite"
                aria-atomic="true"
              >
                <SignupConfirm tncHtml={smsDisclaimer} susbscriptionType="sms" isSMS />
                <Row className="button-wrapper" fullBleed>
                  <Col colSize={{ small: 4, medium: 4, large: 4 }} className="button-container">
                    <Anchor
                      to={this.shopNowBtnUrl}
                      asPath={this.shopNowBtnUrl}
                      target={this.shopNowBtnUrlTarget}
                      onClick={closeModal}
                    >
                      <Button
                        fullWidth
                        buttonVariation="fixed-width"
                        fill="BLUE"
                        type="submit"
                        className="shop-button"
                        dataLocator="shop_now_btn"
                      >
                        {this.shopNowLabel}
                      </Button>
                    </Anchor>
                  </Col>
                  {noModal && (
                    <Col
                      colSize={{ small: 4, medium: 4, large: 4 }}
                      className="button-container"
                      offsetLeft={{ large: 2, small: 0, medium: 0 }}
                    >
                      <Anchor to={this.storeLocatorUrl} asPath={this.storeLocatorUrl}>
                        <Button
                          fullWidth
                          buttonVariation="fixed-width"
                          fill="BLUE"
                          type="submit"
                          className="shop-button"
                          dataLocator="store-locator_btn"
                        >
                          {this.storeLocatorLabelText}
                        </Button>
                      </Anchor>
                    </Col>
                  )}
                </Row>
                {noModal && (
                  <Row>
                    <Col colSize={{ large: 10, medium: 8, small: 6 }} className="termscontainer">
                      {smsDisclaimer && smsDisclaimer.richText ? (
                        <RichText richTextHtml={smsDisclaimer.richText} />
                      ) : null}
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          </Grid>
        ) : (
          <form onSubmit={handleSubmit(this.submitForm)}>
            <Grid>
              <Row
                fullBleed={{ large: true }}
                className={`${className} wrapper form_container ${
                  noModal ? 'smssubscribe__wrapper' : ''
                }`}
              >
                {!noModal && (
                  <Col
                    isNotInlineBlock
                    colSize={left}
                    hideCol={{ small: true, medium: true }}
                    className="img-wrapper"
                  >
                    <DamImage
                      imgConfigs={noModal ? IMG_DATA_PAGE : IMG_DATA_MODAL}
                      imgData={this.getImageData()}
                    />
                  </Col>
                )}
                <Col colSize={right} className="smsform__wrapper form-wrapper marginRightZero">
                  <div className="smsform__content">
                    <Row fullBleed>
                      {!noModal && (
                        <Col
                          colSize={{ small: 6, medium: 6, large: 10 }}
                          offsetLeft={{ small: 0, medium: 1, large: 1 }}
                          className="logo-wrapper"
                        >
                          <Image
                            className={'logo'}
                            aria-hidden="true"
                            src={getIconPath(`header__brand-tab-${brand}`)}
                          />
                        </Col>
                      )}
                    </Row>
                    <SignupFormIntro
                      noModal={noModal}
                      isSMS
                      fromPage={fromPage}
                      susbscriptionType="sms"
                    />
                    <Col
                      colSize={{ small: 6, medium: 6, large: noModal ? 8 : 12 }}
                      offsetLeft={{ small: 0, medium: 1, large: 0 }}
                      className="field-container"
                    >
                      <Field
                        placeholder={this.placeholderLabelText}
                        name="signupPhoneNumber"
                        id="signupPhoneNumber"
                        type="text"
                        component={TextBox}
                        maxLength={50}
                        dataLocator="sms_address_field"
                        normalize={formatPhoneNumber}
                        enableSuccessCheck={false}
                      />

                      {!isCanadaCheck && (
                        <Field
                          name="optPhoneSignupSecondBrand"
                          id="optPhoneSignupSecondBrand"
                          className="phone-signup-second-brand"
                          component={InputCheckbox}
                          dataLocator={`sms_${brand}_opt`}
                          type="checkbox"
                        >
                          {checkBoxBrandLabelText}
                        </Field>
                      )}

                      {!noModal && (
                        <div className="termscontainer">
                          {smsDisclaimer && smsDisclaimer.richText ? (
                            <RichText richTextHtml={smsDisclaimer.richText} />
                          ) : null}
                        </div>
                      )}
                    </Col>
                    <Row className="button-wrapper-form" fullBleed>
                      <Col
                        colSize={{ small: 4, medium: 4, large: 6 }}
                        className="button-wrapper-form__joinnowbtn"
                      >
                        <Button
                          disabled={!valid || submitting}
                          fullWidth
                          buttonVariation="fixed-width"
                          fill={SNJ_HP_PRIMARY_FILL[`${getBrandInCaps()}`]}
                          type="submit"
                          className="join-button"
                          dataLocator="join_now_btn"
                        >
                          <span>{this.joinButtonLabelText}</span>
                        </Button>
                        {
                          // styled components issue while updating tests on this page
                        }
                      </Col>
                      {smsFromPage !== 'landing' && (
                        <Row>
                          <Col
                            className="no-thanks-wrapper"
                            colSize={{ small: 4, medium: 4, large: 6 }}
                          >
                            <Anchor
                              className="no-thanks-sms"
                              handleLinkClick={(e) => {
                                e.preventDefault();
                                closeModal();
                              }}
                              noLink
                            >
                              {this.emailSignUpNoThanksText}
                            </Anchor>
                          </Col>
                        </Row>
                      )}
                    </Row>
                    {noModal && (
                      <Row>
                        <Col
                          colSize={{ large: 10, medium: 8, small: 6 }}
                          className="termscontainer"
                        >
                          {smsDisclaimer && smsDisclaimer.richText ? (
                            <RichText richTextHtml={smsDisclaimer.richText} />
                          ) : null}
                        </Col>
                      </Row>
                    )}
                  </div>
                </Col>
              </Row>
            </Grid>
          </form>
        )}
      </Fragment>
    );
  }
}

SmsSignupForm.propTypes = {
  buttonConfig: PropTypes.shape({}),
  className: PropTypes.string,
  confirmationViewConfig: PropTypes.shape({}).isRequired,
  clearSmsSignupForm: PropTypes.func,
  subscription: PropTypes.shape({}),
  submitSmsSubscription: PropTypes.func,
  validateSignupSmsPhoneNumber: PropTypes.func,
  trackSubscriptionSuccess: PropTypes.func,
  valid: PropTypes.bool,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  colProps: PropTypes.shape({
    left: PropTypes.shape({}),
    right: PropTypes.shape({}),
  }),
  noModal: PropTypes.bool,
  imageData: PropTypes.shape({}),
  closeModal: PropTypes.func,
  defaultStore: PropTypes.shape({}),
  smsDisclaimer: PropTypes.shape({}),
  smsFromPage: PropTypes.string.isRequired,
  fromPage: PropTypes.string,
};

SmsSignupForm.defaultProps = {
  buttonConfig: {},
  className: '',
  subscription: {},
  submitSmsSubscription: () => {},
  trackSubscriptionSuccess: () => {},
  validateSignupSmsPhoneNumber: () => Promise.resolve({}),
  clearSmsSignupForm: () => {},
  handleSubmit: () => {},
  valid: false,
  submitting: false,
  colProps: {},
  noModal: false,
  imageData: {},
  closeModal: () => {},
  defaultStore: {},
  smsDisclaimer: {},
  fromPage: '',
};

const validateMethod = createValidateMethod(getStandardConfig(['userAge', 'SmsSignupForm']));
export default withStyles(
  reduxForm({
    form: 'SmsSignupForm',
    initialValues: {
      signupPhoneNumber: '',
    },
    ...validateMethod,
  })(SmsSignupForm),
  smsSignupStyle
);
export { SmsSignupForm as SmsSignupFormVanilla };
